import { useDispatch } from "react-redux";
import { updateKitByProduct } from "../../slices/productsSlice";
import { LoaderSpinner } from "../LoaderSpinner";

export const IsKit = ({
    product,
    access,
    isLoading,
    withoutLoader = false,
    groupUpdate,
    updateCallback,
    containerClassname
}) => {
    const dispatch = useDispatch();

    const handleIsKitChange = async (productId, kitValue) => {
        if (access === "edit") {
            await dispatch(updateKitByProduct({
                productId,
                isKitManually: kitValue || false,
                requestToUpdate: groupUpdate,
            }));
            await updateCallback?.();
        }
    };

    return (
        <div className="relative">
            <div className={`flex items-center gap-2 ${containerClassname || ""}`}>
                {(isLoading && !withoutLoader) && (<LoaderSpinner height='20' width='20' colorSpinner='black' border='3' />)}
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        key={`${product.isManualKit}`}
                        type="checkbox"
                        checked={product.isManualKit}
                        onChange={(e) => {
                            handleIsKitChange(product.id, e.target.checked);
                        }}
                        disabled={isLoading || access !== "edit"}
                        className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
            </div>
        </div>
    )
}